import React, {createContext} from 'react';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import { FormValidator, Field } from '../../utility/FormValidator';
import PropTypes from 'prop-types';
import {
    Input,
    InputField,
    SimpleSelect,
    SimpleSelectMultiple
} from '../';


const isChildrenEmpty = (children) => {
    return React.Children.count(children) === 0;
}

var createNamedContext =  (name) =>{
    var context = createContext();
    context.displayName = name;
    return context;
};

var validationContext =
/*#__PURE__*/
createNamedContext("Validation");
  
var createNamedContext$1 =  (name) => {
    var context = createContext();
    context.displayName = name;
    return context;
  };

var context =
/*#__PURE__*/
createNamedContext$1  ("ValidateField");

var ValidateField =
/*#__PURE__*/
function (_React$Component) {
  
    _inheritsLoose(ValidateField, _React$Component);

    function ValidateField(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        
        _this.state = { 
            fieldName: ''
        }

        _this.onFieldBlur = _this.onFieldBlur.bind(_this);
        return _this;
    }

    var _proto = ValidateField.prototype;
    _proto.validator = FormValidator.getInstance(FormValidator);
    _proto.inputBindings = function inputBindings() {
        
        const children  = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
        
        const inputField = children.find((child) => this.isInputField( child) || this.isComponentSelect(child));
        const errorFeedbacks = children.filter((child) => child.type && child.type.name === ErrorFeedback.name);
    
        if (inputField) {
    
            const {pattern, require, matchField} = this.props;
            const validator = this.validator;
            const component = this.isComponentSelect(inputField) ? inputField : null;

            const nameAttr = inputField.name || inputField.props.name;
            if (!nameAttr) {
                throw new Error("[Name] attribute is required on input field.");
            } 
            
            if ((component && !component.ref ) ) {
                throw new Error("[Ref] attribute is required on component props.");
            }

            validator.addValidateField(inputField.props.name, errorFeedbacks, {
                pattern: pattern,
                require: require,
                matchField: matchField
            }, component);
            
            const field = document.querySelector(`[name=${nameAttr}]`);
            field && field.addEventListener('focusout', this.onFieldBlur, true);
            this.setState({fieldName: inputField.props.name});
        }
    };

    _proto.isInputField = function isInputField(child) {
        return child.type === Input || child.type === InputField || child.type === 'input';
    }

    _proto.isComponentSelect = function isComponentSelect(child) {
        return child.type === SimpleSelect || child.type === SimpleSelectMultiple;     
    }

    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.inputBindings();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this.unBind();
    };

    _proto.onFieldBlur = function onFieldBlur (evt) {
        const fieldName = evt.currentTarget.getAttribute('name');
        setTimeout(() => {
            this.validator.validateField(fieldName);
            this.forceUpdate();
        }, 200);
    }

    _proto.unBind = function unBind () {
        const children  = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
        
        const inputField = children.find((child) => this.isInputField(child) || this.isComponentSelect(child));

        if (inputField) {
            const nameAttr = inputField.name || inputField.props.name;
            this.validator.removeValidateField(nameAttr);
            const field = document.querySelector(`[name=${nameAttr}]`);
            field && field.removeEventListener('blur', this.onFieldBlur);
        }
    }
    
    _proto.render = function render() {
        
        return React.createElement(context.Provider, {
            value: {
              validator: this.validator,
              fieldName: this.state.fieldName,
              staticContext: this.props.staticContext
            }
          }, React.createElement(validationContext.Provider, {
            children: this.props.children || null,
            value:  this.props.validator
        })); 
    }

  return ValidateField;
  

}(React.Component)
ValidateField.propTypes = {
    children: PropTypes.node.isRequired,
    required:  PropTypes.bool,
    pattern:  PropTypes.string,
    matchField: PropTypes.string
};


var ErrorFeedback =
/*#__PURE__*/
function (_React$Component) {
    _inheritsLoose(ErrorFeedback, _React$Component);

    function ErrorFeedback() {
        return _React$Component.apply(this, arguments) || this;
    }

    var _proto = ErrorFeedback.prototype;
    _proto.render = function render() {

        return React.createElement(context.Consumer, null, (context$1) => {
            if (!context$1) {
                return new Error("You should not use <ErrorFeedback> outside a <ValidateField>");
            }  

            const field = context$1.validator.getValidateField(context$1.fieldName);
            const classSuffix = this.props.error ? 'error' : 'warning'; 
            const errorKey = `${this.props.filter}_${classSuffix}`;
            const show = this.props.show === undefined ? false : this.props.show;
            const message = this.props.message || '';
          
            let matchFeedback = null;
            let showError = false;
            
            if (!show && field !== undefined) {
                matchFeedback = !field.element  ? null  : field.element.feedbackMessages[errorKey];
                showError =  matchFeedback;
            }else {
                showError = show;
            }
            
            return !showError ? null : message.empty() ? null : <span className={`form-${classSuffix}`}>{message}</span>
        });
    }

    return ErrorFeedback;
}(React.Component);

ErrorFeedback.propTypes = {
    children: PropTypes.func,
    error:    PropTypes.bool,
    warning:  PropTypes.bool,
    show: PropTypes.bool,
    filter:   PropTypes.string.isRequired,
    message:  PropTypes.node.isRequired
};

export {ValidateField, ErrorFeedback}